var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"sub-container"},[_c('h3',{staticClass:"budget-header"},[_vm._v("Крупные плательщики")]),_c('filter-row',{attrs:{"select-data":_vm.filter}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }